import type { IGiftCardCartItem } from '../../types/cart'

export function isIGiftCardCartItem(arg: unknown): arg is IGiftCardCartItem {
  return (arg as IGiftCardCartItem).recipientDetails !== undefined
}
